var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","link":""},on:{"click":function($event){return _vm.doGetStaffLink()}}},[_c('span',{staticClass:"lbl-textbox"},[_vm._t("default",[_vm._v("Details")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }